/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ErrorGenericRouteImport } from './routes/error/generic'
import { Route as Error503RouteImport } from './routes/error/503'
import { Route as Error502RouteImport } from './routes/error/502'
import { Route as Error500RouteImport } from './routes/error/500'
import { Route as Error404RouteImport } from './routes/error/404'
import { Route as Error403RouteImport } from './routes/error/403'
import { Route as Error400RouteImport } from './routes/error/400'
import { Route as AuthenticatedSetupPendingRouteImport } from './routes/_authenticated/setup-pending'
import { Route as AuthenticatedNoAccessRouteImport } from './routes/_authenticated/no-access'
import { Route as AuthenticatedWithWorkspaceRouteImport } from './routes/_authenticated/_withWorkspace'
import { Route as AuthenticatedExcelAuthorizeRouteImport } from './routes/_authenticated/excel.authorize'
import { Route as AuthenticatedWithWorkspaceSettingsRouteImport } from './routes/_authenticated/_withWorkspace/settings'
import { Route as AuthenticatedWithWorkspacePromptsRouteImport } from './routes/_authenticated/_withWorkspace/prompts'
import { Route as AuthenticatedWithWorkspaceInputsRouteImport } from './routes/_authenticated/_withWorkspace/inputs'
import { Route as AuthenticatedWithWorkspaceActivityRouteImport } from './routes/_authenticated/_withWorkspace/activity'
import { Route as AuthenticatedWithWorkspaceWorkspaceIndexRouteImport } from './routes/_authenticated/_withWorkspace/workspace/index'
import { Route as AuthenticatedWithWorkspaceVersionsIndexRouteImport } from './routes/_authenticated/_withWorkspace/versions/index'
import { Route as AuthenticatedWithWorkspaceSettingsIndexRouteImport } from './routes/_authenticated/_withWorkspace/settings.index'
import { Route as AuthenticatedConnectorsHubspotCallbackRouteImport } from './routes/_authenticated/connectors.hubspot.callback'
import { Route as AuthenticatedWithWorkspaceWorkspaceTrashRouteImport } from './routes/_authenticated/_withWorkspace/workspace/trash'
import { Route as AuthenticatedWithWorkspaceWorkspaceRecentRouteImport } from './routes/_authenticated/_withWorkspace/workspace/recent'
import { Route as AuthenticatedWithWorkspaceWorkspaceFavoritesRouteImport } from './routes/_authenticated/_withWorkspace/workspace/favorites'
import { Route as AuthenticatedWithWorkspaceVersionsProgressRouteImport } from './routes/_authenticated/_withWorkspace/versions/progress'
import { Route as AuthenticatedWithWorkspaceVersionsNewRouteImport } from './routes/_authenticated/_withWorkspace/versions/new'
import { Route as AuthenticatedWithWorkspaceSettingsNotificationsRouteImport } from './routes/_authenticated/_withWorkspace/settings.notifications'
import { Route as AuthenticatedWithWorkspaceSettingsMembersRouteImport } from './routes/_authenticated/_withWorkspace/settings.members'
import { Route as AuthenticatedWithWorkspaceSettingsGeneralRouteImport } from './routes/_authenticated/_withWorkspace/settings.general'
import { Route as AuthenticatedWithWorkspaceSettingsBillingRouteImport } from './routes/_authenticated/_withWorkspace/settings.billing'
import { Route as AuthenticatedWithWorkspaceSettingsApiRouteImport } from './routes/_authenticated/_withWorkspace/settings.api'
import { Route as AuthenticatedWithWorkspaceWorkspaceFolderIdRouteImport } from './routes/_authenticated/_withWorkspace/workspace/folder/$id'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorGenericRoute = ErrorGenericRouteImport.update({
  id: '/error/generic',
  path: '/error/generic',
  getParentRoute: () => rootRouteImport,
} as any)
const Error503Route = Error503RouteImport.update({
  id: '/error/503',
  path: '/error/503',
  getParentRoute: () => rootRouteImport,
} as any)
const Error502Route = Error502RouteImport.update({
  id: '/error/502',
  path: '/error/502',
  getParentRoute: () => rootRouteImport,
} as any)
const Error500Route = Error500RouteImport.update({
  id: '/error/500',
  path: '/error/500',
  getParentRoute: () => rootRouteImport,
} as any)
const Error404Route = Error404RouteImport.update({
  id: '/error/404',
  path: '/error/404',
  getParentRoute: () => rootRouteImport,
} as any)
const Error403Route = Error403RouteImport.update({
  id: '/error/403',
  path: '/error/403',
  getParentRoute: () => rootRouteImport,
} as any)
const Error400Route = Error400RouteImport.update({
  id: '/error/400',
  path: '/error/400',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSetupPendingRoute =
  AuthenticatedSetupPendingRouteImport.update({
    id: '/setup-pending',
    path: '/setup-pending',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNoAccessRoute = AuthenticatedNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWithWorkspaceRoute =
  AuthenticatedWithWorkspaceRouteImport.update({
    id: '/_withWorkspace',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExcelAuthorizeRoute =
  AuthenticatedExcelAuthorizeRouteImport.update({
    id: '/excel/authorize',
    path: '/excel/authorize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsRoute =
  AuthenticatedWithWorkspaceSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspacePromptsRoute =
  AuthenticatedWithWorkspacePromptsRouteImport.update({
    id: '/prompts',
    path: '/prompts',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceInputsRoute =
  AuthenticatedWithWorkspaceInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceActivityRoute =
  AuthenticatedWithWorkspaceActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceWorkspaceIndexRoute =
  AuthenticatedWithWorkspaceWorkspaceIndexRouteImport.update({
    id: '/workspace/',
    path: '/workspace/',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceVersionsIndexRoute =
  AuthenticatedWithWorkspaceVersionsIndexRouteImport.update({
    id: '/versions/',
    path: '/versions/',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsIndexRoute =
  AuthenticatedWithWorkspaceSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedConnectorsHubspotCallbackRoute =
  AuthenticatedConnectorsHubspotCallbackRouteImport.update({
    id: '/connectors/hubspot/callback',
    path: '/connectors/hubspot/callback',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWithWorkspaceWorkspaceTrashRoute =
  AuthenticatedWithWorkspaceWorkspaceTrashRouteImport.update({
    id: '/workspace/trash',
    path: '/workspace/trash',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceWorkspaceRecentRoute =
  AuthenticatedWithWorkspaceWorkspaceRecentRouteImport.update({
    id: '/workspace/recent',
    path: '/workspace/recent',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceWorkspaceFavoritesRoute =
  AuthenticatedWithWorkspaceWorkspaceFavoritesRouteImport.update({
    id: '/workspace/favorites',
    path: '/workspace/favorites',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceVersionsProgressRoute =
  AuthenticatedWithWorkspaceVersionsProgressRouteImport.update({
    id: '/versions/progress',
    path: '/versions/progress',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceVersionsNewRoute =
  AuthenticatedWithWorkspaceVersionsNewRouteImport.update({
    id: '/versions/new',
    path: '/versions/new',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsNotificationsRoute =
  AuthenticatedWithWorkspaceSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsMembersRoute =
  AuthenticatedWithWorkspaceSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsGeneralRoute =
  AuthenticatedWithWorkspaceSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsBillingRoute =
  AuthenticatedWithWorkspaceSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedWithWorkspaceSettingsApiRoute =
  AuthenticatedWithWorkspaceSettingsApiRouteImport.update({
    id: '/api',
    path: '/api',
    getParentRoute: () => AuthenticatedWithWorkspaceSettingsRoute,
  } as any)
const AuthenticatedWithWorkspaceWorkspaceFolderIdRoute =
  AuthenticatedWithWorkspaceWorkspaceFolderIdRouteImport.update({
    id: '/workspace/folder/$id',
    path: '/workspace/folder/$id',
    getParentRoute: () => AuthenticatedWithWorkspaceRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/setup-pending': typeof AuthenticatedSetupPendingRoute
  '/error/400': typeof Error400Route
  '/error/403': typeof Error403Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/502': typeof Error502Route
  '/error/503': typeof Error503Route
  '/error/generic': typeof ErrorGenericRoute
  '/activity': typeof AuthenticatedWithWorkspaceActivityRoute
  '/inputs': typeof AuthenticatedWithWorkspaceInputsRoute
  '/prompts': typeof AuthenticatedWithWorkspacePromptsRoute
  '/settings': typeof AuthenticatedWithWorkspaceSettingsRouteWithChildren
  '/excel/authorize': typeof AuthenticatedExcelAuthorizeRoute
  '/settings/api': typeof AuthenticatedWithWorkspaceSettingsApiRoute
  '/settings/billing': typeof AuthenticatedWithWorkspaceSettingsBillingRoute
  '/settings/general': typeof AuthenticatedWithWorkspaceSettingsGeneralRoute
  '/settings/members': typeof AuthenticatedWithWorkspaceSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedWithWorkspaceSettingsNotificationsRoute
  '/versions/new': typeof AuthenticatedWithWorkspaceVersionsNewRoute
  '/versions/progress': typeof AuthenticatedWithWorkspaceVersionsProgressRoute
  '/workspace/favorites': typeof AuthenticatedWithWorkspaceWorkspaceFavoritesRoute
  '/workspace/recent': typeof AuthenticatedWithWorkspaceWorkspaceRecentRoute
  '/workspace/trash': typeof AuthenticatedWithWorkspaceWorkspaceTrashRoute
  '/connectors/hubspot/callback': typeof AuthenticatedConnectorsHubspotCallbackRoute
  '/settings/': typeof AuthenticatedWithWorkspaceSettingsIndexRoute
  '/versions': typeof AuthenticatedWithWorkspaceVersionsIndexRoute
  '/workspace': typeof AuthenticatedWithWorkspaceWorkspaceIndexRoute
  '/workspace/folder/$id': typeof AuthenticatedWithWorkspaceWorkspaceFolderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/setup-pending': typeof AuthenticatedSetupPendingRoute
  '/error/400': typeof Error400Route
  '/error/403': typeof Error403Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/502': typeof Error502Route
  '/error/503': typeof Error503Route
  '/error/generic': typeof ErrorGenericRoute
  '/activity': typeof AuthenticatedWithWorkspaceActivityRoute
  '/inputs': typeof AuthenticatedWithWorkspaceInputsRoute
  '/prompts': typeof AuthenticatedWithWorkspacePromptsRoute
  '/excel/authorize': typeof AuthenticatedExcelAuthorizeRoute
  '/settings/api': typeof AuthenticatedWithWorkspaceSettingsApiRoute
  '/settings/billing': typeof AuthenticatedWithWorkspaceSettingsBillingRoute
  '/settings/general': typeof AuthenticatedWithWorkspaceSettingsGeneralRoute
  '/settings/members': typeof AuthenticatedWithWorkspaceSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedWithWorkspaceSettingsNotificationsRoute
  '/versions/new': typeof AuthenticatedWithWorkspaceVersionsNewRoute
  '/versions/progress': typeof AuthenticatedWithWorkspaceVersionsProgressRoute
  '/workspace/favorites': typeof AuthenticatedWithWorkspaceWorkspaceFavoritesRoute
  '/workspace/recent': typeof AuthenticatedWithWorkspaceWorkspaceRecentRoute
  '/workspace/trash': typeof AuthenticatedWithWorkspaceWorkspaceTrashRoute
  '/connectors/hubspot/callback': typeof AuthenticatedConnectorsHubspotCallbackRoute
  '/settings': typeof AuthenticatedWithWorkspaceSettingsIndexRoute
  '/versions': typeof AuthenticatedWithWorkspaceVersionsIndexRoute
  '/workspace': typeof AuthenticatedWithWorkspaceWorkspaceIndexRoute
  '/workspace/folder/$id': typeof AuthenticatedWithWorkspaceWorkspaceFolderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authenticated/_withWorkspace': typeof AuthenticatedWithWorkspaceRouteWithChildren
  '/_authenticated/no-access': typeof AuthenticatedNoAccessRoute
  '/_authenticated/setup-pending': typeof AuthenticatedSetupPendingRoute
  '/error/400': typeof Error400Route
  '/error/403': typeof Error403Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/502': typeof Error502Route
  '/error/503': typeof Error503Route
  '/error/generic': typeof ErrorGenericRoute
  '/_authenticated/_withWorkspace/activity': typeof AuthenticatedWithWorkspaceActivityRoute
  '/_authenticated/_withWorkspace/inputs': typeof AuthenticatedWithWorkspaceInputsRoute
  '/_authenticated/_withWorkspace/prompts': typeof AuthenticatedWithWorkspacePromptsRoute
  '/_authenticated/_withWorkspace/settings': typeof AuthenticatedWithWorkspaceSettingsRouteWithChildren
  '/_authenticated/excel/authorize': typeof AuthenticatedExcelAuthorizeRoute
  '/_authenticated/_withWorkspace/settings/api': typeof AuthenticatedWithWorkspaceSettingsApiRoute
  '/_authenticated/_withWorkspace/settings/billing': typeof AuthenticatedWithWorkspaceSettingsBillingRoute
  '/_authenticated/_withWorkspace/settings/general': typeof AuthenticatedWithWorkspaceSettingsGeneralRoute
  '/_authenticated/_withWorkspace/settings/members': typeof AuthenticatedWithWorkspaceSettingsMembersRoute
  '/_authenticated/_withWorkspace/settings/notifications': typeof AuthenticatedWithWorkspaceSettingsNotificationsRoute
  '/_authenticated/_withWorkspace/versions/new': typeof AuthenticatedWithWorkspaceVersionsNewRoute
  '/_authenticated/_withWorkspace/versions/progress': typeof AuthenticatedWithWorkspaceVersionsProgressRoute
  '/_authenticated/_withWorkspace/workspace/favorites': typeof AuthenticatedWithWorkspaceWorkspaceFavoritesRoute
  '/_authenticated/_withWorkspace/workspace/recent': typeof AuthenticatedWithWorkspaceWorkspaceRecentRoute
  '/_authenticated/_withWorkspace/workspace/trash': typeof AuthenticatedWithWorkspaceWorkspaceTrashRoute
  '/_authenticated/connectors/hubspot/callback': typeof AuthenticatedConnectorsHubspotCallbackRoute
  '/_authenticated/_withWorkspace/settings/': typeof AuthenticatedWithWorkspaceSettingsIndexRoute
  '/_authenticated/_withWorkspace/versions/': typeof AuthenticatedWithWorkspaceVersionsIndexRoute
  '/_authenticated/_withWorkspace/workspace/': typeof AuthenticatedWithWorkspaceWorkspaceIndexRoute
  '/_authenticated/_withWorkspace/workspace/folder/$id': typeof AuthenticatedWithWorkspaceWorkspaceFolderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/login'
    | '/signup'
    | '/no-access'
    | '/setup-pending'
    | '/error/400'
    | '/error/403'
    | '/error/404'
    | '/error/500'
    | '/error/502'
    | '/error/503'
    | '/error/generic'
    | '/activity'
    | '/inputs'
    | '/prompts'
    | '/settings'
    | '/excel/authorize'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/members'
    | '/settings/notifications'
    | '/versions/new'
    | '/versions/progress'
    | '/workspace/favorites'
    | '/workspace/recent'
    | '/workspace/trash'
    | '/connectors/hubspot/callback'
    | '/settings/'
    | '/versions'
    | '/workspace'
    | '/workspace/folder/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/login'
    | '/signup'
    | '/no-access'
    | '/setup-pending'
    | '/error/400'
    | '/error/403'
    | '/error/404'
    | '/error/500'
    | '/error/502'
    | '/error/503'
    | '/error/generic'
    | '/activity'
    | '/inputs'
    | '/prompts'
    | '/excel/authorize'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/members'
    | '/settings/notifications'
    | '/versions/new'
    | '/versions/progress'
    | '/workspace/favorites'
    | '/workspace/recent'
    | '/workspace/trash'
    | '/connectors/hubspot/callback'
    | '/settings'
    | '/versions'
    | '/workspace'
    | '/workspace/folder/$id'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/_authenticated'
    | '/login'
    | '/signup'
    | '/_authenticated/_withWorkspace'
    | '/_authenticated/no-access'
    | '/_authenticated/setup-pending'
    | '/error/400'
    | '/error/403'
    | '/error/404'
    | '/error/500'
    | '/error/502'
    | '/error/503'
    | '/error/generic'
    | '/_authenticated/_withWorkspace/activity'
    | '/_authenticated/_withWorkspace/inputs'
    | '/_authenticated/_withWorkspace/prompts'
    | '/_authenticated/_withWorkspace/settings'
    | '/_authenticated/excel/authorize'
    | '/_authenticated/_withWorkspace/settings/api'
    | '/_authenticated/_withWorkspace/settings/billing'
    | '/_authenticated/_withWorkspace/settings/general'
    | '/_authenticated/_withWorkspace/settings/members'
    | '/_authenticated/_withWorkspace/settings/notifications'
    | '/_authenticated/_withWorkspace/versions/new'
    | '/_authenticated/_withWorkspace/versions/progress'
    | '/_authenticated/_withWorkspace/workspace/favorites'
    | '/_authenticated/_withWorkspace/workspace/recent'
    | '/_authenticated/_withWorkspace/workspace/trash'
    | '/_authenticated/connectors/hubspot/callback'
    | '/_authenticated/_withWorkspace/settings/'
    | '/_authenticated/_withWorkspace/versions/'
    | '/_authenticated/_withWorkspace/workspace/'
    | '/_authenticated/_withWorkspace/workspace/folder/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  Error400Route: typeof Error400Route
  Error403Route: typeof Error403Route
  Error404Route: typeof Error404Route
  Error500Route: typeof Error500Route
  Error502Route: typeof Error502Route
  Error503Route: typeof Error503Route
  ErrorGenericRoute: typeof ErrorGenericRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/generic': {
      id: '/error/generic'
      path: '/error/generic'
      fullPath: '/error/generic'
      preLoaderRoute: typeof ErrorGenericRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/503': {
      id: '/error/503'
      path: '/error/503'
      fullPath: '/error/503'
      preLoaderRoute: typeof Error503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/502': {
      id: '/error/502'
      path: '/error/502'
      fullPath: '/error/502'
      preLoaderRoute: typeof Error502RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/500': {
      id: '/error/500'
      path: '/error/500'
      fullPath: '/error/500'
      preLoaderRoute: typeof Error500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/404': {
      id: '/error/404'
      path: '/error/404'
      fullPath: '/error/404'
      preLoaderRoute: typeof Error404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/403': {
      id: '/error/403'
      path: '/error/403'
      fullPath: '/error/403'
      preLoaderRoute: typeof Error403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/400': {
      id: '/error/400'
      path: '/error/400'
      fullPath: '/error/400'
      preLoaderRoute: typeof Error400RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/setup-pending': {
      id: '/_authenticated/setup-pending'
      path: '/setup-pending'
      fullPath: '/setup-pending'
      preLoaderRoute: typeof AuthenticatedSetupPendingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/no-access': {
      id: '/_authenticated/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthenticatedNoAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_withWorkspace': {
      id: '/_authenticated/_withWorkspace'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedWithWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/excel/authorize': {
      id: '/_authenticated/excel/authorize'
      path: '/excel/authorize'
      fullPath: '/excel/authorize'
      preLoaderRoute: typeof AuthenticatedExcelAuthorizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_withWorkspace/settings': {
      id: '/_authenticated/_withWorkspace/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/prompts': {
      id: '/_authenticated/_withWorkspace/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedWithWorkspacePromptsRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/inputs': {
      id: '/_authenticated/_withWorkspace/inputs'
      path: '/inputs'
      fullPath: '/inputs'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceInputsRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/activity': {
      id: '/_authenticated/_withWorkspace/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceActivityRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/workspace/': {
      id: '/_authenticated/_withWorkspace/workspace/'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceWorkspaceIndexRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/versions/': {
      id: '/_authenticated/_withWorkspace/versions/'
      path: '/versions'
      fullPath: '/versions'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceVersionsIndexRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/settings/': {
      id: '/_authenticated/_withWorkspace/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/connectors/hubspot/callback': {
      id: '/_authenticated/connectors/hubspot/callback'
      path: '/connectors/hubspot/callback'
      fullPath: '/connectors/hubspot/callback'
      preLoaderRoute: typeof AuthenticatedConnectorsHubspotCallbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_withWorkspace/workspace/trash': {
      id: '/_authenticated/_withWorkspace/workspace/trash'
      path: '/workspace/trash'
      fullPath: '/workspace/trash'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceWorkspaceTrashRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/workspace/recent': {
      id: '/_authenticated/_withWorkspace/workspace/recent'
      path: '/workspace/recent'
      fullPath: '/workspace/recent'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceWorkspaceRecentRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/workspace/favorites': {
      id: '/_authenticated/_withWorkspace/workspace/favorites'
      path: '/workspace/favorites'
      fullPath: '/workspace/favorites'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceWorkspaceFavoritesRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/versions/progress': {
      id: '/_authenticated/_withWorkspace/versions/progress'
      path: '/versions/progress'
      fullPath: '/versions/progress'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceVersionsProgressRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/versions/new': {
      id: '/_authenticated/_withWorkspace/versions/new'
      path: '/versions/new'
      fullPath: '/versions/new'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceVersionsNewRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
    '/_authenticated/_withWorkspace/settings/notifications': {
      id: '/_authenticated/_withWorkspace/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/_withWorkspace/settings/members': {
      id: '/_authenticated/_withWorkspace/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/_withWorkspace/settings/general': {
      id: '/_authenticated/_withWorkspace/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/_withWorkspace/settings/billing': {
      id: '/_authenticated/_withWorkspace/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/_withWorkspace/settings/api': {
      id: '/_authenticated/_withWorkspace/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceSettingsApiRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceSettingsRoute
    }
    '/_authenticated/_withWorkspace/workspace/folder/$id': {
      id: '/_authenticated/_withWorkspace/workspace/folder/$id'
      path: '/workspace/folder/$id'
      fullPath: '/workspace/folder/$id'
      preLoaderRoute: typeof AuthenticatedWithWorkspaceWorkspaceFolderIdRouteImport
      parentRoute: typeof AuthenticatedWithWorkspaceRoute
    }
  }
}

interface AuthenticatedWithWorkspaceSettingsRouteChildren {
  AuthenticatedWithWorkspaceSettingsApiRoute: typeof AuthenticatedWithWorkspaceSettingsApiRoute
  AuthenticatedWithWorkspaceSettingsBillingRoute: typeof AuthenticatedWithWorkspaceSettingsBillingRoute
  AuthenticatedWithWorkspaceSettingsGeneralRoute: typeof AuthenticatedWithWorkspaceSettingsGeneralRoute
  AuthenticatedWithWorkspaceSettingsMembersRoute: typeof AuthenticatedWithWorkspaceSettingsMembersRoute
  AuthenticatedWithWorkspaceSettingsNotificationsRoute: typeof AuthenticatedWithWorkspaceSettingsNotificationsRoute
  AuthenticatedWithWorkspaceSettingsIndexRoute: typeof AuthenticatedWithWorkspaceSettingsIndexRoute
}

const AuthenticatedWithWorkspaceSettingsRouteChildren: AuthenticatedWithWorkspaceSettingsRouteChildren =
  {
    AuthenticatedWithWorkspaceSettingsApiRoute:
      AuthenticatedWithWorkspaceSettingsApiRoute,
    AuthenticatedWithWorkspaceSettingsBillingRoute:
      AuthenticatedWithWorkspaceSettingsBillingRoute,
    AuthenticatedWithWorkspaceSettingsGeneralRoute:
      AuthenticatedWithWorkspaceSettingsGeneralRoute,
    AuthenticatedWithWorkspaceSettingsMembersRoute:
      AuthenticatedWithWorkspaceSettingsMembersRoute,
    AuthenticatedWithWorkspaceSettingsNotificationsRoute:
      AuthenticatedWithWorkspaceSettingsNotificationsRoute,
    AuthenticatedWithWorkspaceSettingsIndexRoute:
      AuthenticatedWithWorkspaceSettingsIndexRoute,
  }

const AuthenticatedWithWorkspaceSettingsRouteWithChildren =
  AuthenticatedWithWorkspaceSettingsRoute._addFileChildren(
    AuthenticatedWithWorkspaceSettingsRouteChildren,
  )

interface AuthenticatedWithWorkspaceRouteChildren {
  AuthenticatedWithWorkspaceActivityRoute: typeof AuthenticatedWithWorkspaceActivityRoute
  AuthenticatedWithWorkspaceInputsRoute: typeof AuthenticatedWithWorkspaceInputsRoute
  AuthenticatedWithWorkspacePromptsRoute: typeof AuthenticatedWithWorkspacePromptsRoute
  AuthenticatedWithWorkspaceSettingsRoute: typeof AuthenticatedWithWorkspaceSettingsRouteWithChildren
  AuthenticatedWithWorkspaceVersionsNewRoute: typeof AuthenticatedWithWorkspaceVersionsNewRoute
  AuthenticatedWithWorkspaceVersionsProgressRoute: typeof AuthenticatedWithWorkspaceVersionsProgressRoute
  AuthenticatedWithWorkspaceWorkspaceFavoritesRoute: typeof AuthenticatedWithWorkspaceWorkspaceFavoritesRoute
  AuthenticatedWithWorkspaceWorkspaceRecentRoute: typeof AuthenticatedWithWorkspaceWorkspaceRecentRoute
  AuthenticatedWithWorkspaceWorkspaceTrashRoute: typeof AuthenticatedWithWorkspaceWorkspaceTrashRoute
  AuthenticatedWithWorkspaceVersionsIndexRoute: typeof AuthenticatedWithWorkspaceVersionsIndexRoute
  AuthenticatedWithWorkspaceWorkspaceIndexRoute: typeof AuthenticatedWithWorkspaceWorkspaceIndexRoute
  AuthenticatedWithWorkspaceWorkspaceFolderIdRoute: typeof AuthenticatedWithWorkspaceWorkspaceFolderIdRoute
}

const AuthenticatedWithWorkspaceRouteChildren: AuthenticatedWithWorkspaceRouteChildren =
  {
    AuthenticatedWithWorkspaceActivityRoute:
      AuthenticatedWithWorkspaceActivityRoute,
    AuthenticatedWithWorkspaceInputsRoute:
      AuthenticatedWithWorkspaceInputsRoute,
    AuthenticatedWithWorkspacePromptsRoute:
      AuthenticatedWithWorkspacePromptsRoute,
    AuthenticatedWithWorkspaceSettingsRoute:
      AuthenticatedWithWorkspaceSettingsRouteWithChildren,
    AuthenticatedWithWorkspaceVersionsNewRoute:
      AuthenticatedWithWorkspaceVersionsNewRoute,
    AuthenticatedWithWorkspaceVersionsProgressRoute:
      AuthenticatedWithWorkspaceVersionsProgressRoute,
    AuthenticatedWithWorkspaceWorkspaceFavoritesRoute:
      AuthenticatedWithWorkspaceWorkspaceFavoritesRoute,
    AuthenticatedWithWorkspaceWorkspaceRecentRoute:
      AuthenticatedWithWorkspaceWorkspaceRecentRoute,
    AuthenticatedWithWorkspaceWorkspaceTrashRoute:
      AuthenticatedWithWorkspaceWorkspaceTrashRoute,
    AuthenticatedWithWorkspaceVersionsIndexRoute:
      AuthenticatedWithWorkspaceVersionsIndexRoute,
    AuthenticatedWithWorkspaceWorkspaceIndexRoute:
      AuthenticatedWithWorkspaceWorkspaceIndexRoute,
    AuthenticatedWithWorkspaceWorkspaceFolderIdRoute:
      AuthenticatedWithWorkspaceWorkspaceFolderIdRoute,
  }

const AuthenticatedWithWorkspaceRouteWithChildren =
  AuthenticatedWithWorkspaceRoute._addFileChildren(
    AuthenticatedWithWorkspaceRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedWithWorkspaceRoute: typeof AuthenticatedWithWorkspaceRouteWithChildren
  AuthenticatedNoAccessRoute: typeof AuthenticatedNoAccessRoute
  AuthenticatedSetupPendingRoute: typeof AuthenticatedSetupPendingRoute
  AuthenticatedExcelAuthorizeRoute: typeof AuthenticatedExcelAuthorizeRoute
  AuthenticatedConnectorsHubspotCallbackRoute: typeof AuthenticatedConnectorsHubspotCallbackRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedWithWorkspaceRoute: AuthenticatedWithWorkspaceRouteWithChildren,
  AuthenticatedNoAccessRoute: AuthenticatedNoAccessRoute,
  AuthenticatedSetupPendingRoute: AuthenticatedSetupPendingRoute,
  AuthenticatedExcelAuthorizeRoute: AuthenticatedExcelAuthorizeRoute,
  AuthenticatedConnectorsHubspotCallbackRoute:
    AuthenticatedConnectorsHubspotCallbackRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  Error400Route: Error400Route,
  Error403Route: Error403Route,
  Error404Route: Error404Route,
  Error500Route: Error500Route,
  Error502Route: Error502Route,
  Error503Route: Error503Route,
  ErrorGenericRoute: ErrorGenericRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
